// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"305e851e","806":"fcb8373d"}[chunkId] + ".chunk.js";
};